export default "__VITE_ASSET__Caifq3WZ__"